exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".copyright-container,\n.link-container {\n  color: rgba(255, 255, 255, 0.5);\n  padding: 12px 20px 0 20px; }\n\na {\n  text-decoration: none; }\n  a:active, a:link, a:visited {\n    color: rgba(255, 255, 255, 0.5); }\n  a:hover {\n    color: #ffffff; }\n\n.copyright-container {\n  background-image: url(\"/assets/images/dvs-logo.png\");\n  background-position: right 20px center;\n  background-repeat: no-repeat;\n  background-size: auto 80%; }\n  .copyright-container a {\n    display: inline-block;\n    font-size: 0.8em;\n    padding-right: 60px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /dist/src/app/ui/footer/footer.component.scss
// module id = ../../../../../src/app/ui/footer/footer.component.scss
// module chunks = main